import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Alert, Row, Col, FormGroup, Label } from 'reactstrap';
import FormCard from '../forms/FormCard';
import Loading from '../Loading';
import IzraktenisMap from '../karte/IzraktenisMap';
import { baseinsStyle, dzurUrbumiStyle } from './DzeramaUdensSatecesBaseinsKartina';
import { renderZemesLietojumsTable } from './DzeramaUdensSatecesBaseinsVisparigaisRaksturojums';
import { exportKopsavilkumsFromDom as exportKopsavilkumsFromDomDocx } from './kopsavilkumsExportDocx';
import NavGeometrijaBridinajums from './NavGeometrijaBridinajums';
import { getRiskLevel as getRiskLevelBase, parseListResult } from './riskaNovertejumsUtils';
import {
    loadRiskaNovertejumiList,
    loadRiskaNovertejums,
    loadRiskaNovertejumuObjekti,
    loadRiskaNovertejumuPasakumi,
    loadRiskaPreventiviePasakumi,
    loadRiskaNovertejumaPreventiviePasakumiSnapshot,
    loadRiskaNovertejumaParametri
} from '../../actions/dzeramaUdensSatecesBaseiniActions';

const getRiskLevel = getRiskLevelBase;

class DzeramaUdensSatecesBaseinsKopsavilkums extends Component {
    state = {
        loading: true,
        preventiviePasakumi: [],
        ietekmesPasakumi: [],
        objektiList: [],
        parametriList: [],
        latestAssessment: null,
        error: null
    };

    mapRef = React.createRef();
    contentRef = React.createRef();

    isAssessmentMode = () => !!this.props.riskaNovertejumsId;

    componentDidMount() {
        this.loadData();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.id !== this.props.id || prevProps.riskaNovertejumsId !== this.props.riskaNovertejumsId) {
            this.loadData();
        } else if (this.props.activeTab === 'kopsavilkums' && prevProps.activeTab !== 'kopsavilkums') {
            this.loadData();
        }
    }

    loadData = async () => {
        if (this.isAssessmentMode()) {
            return this.loadAssessmentData();
        }
        return this.loadBasinData();
    }

    loadAssessmentData = async () => {
        const { riskaNovertejumsId, novertejumsData, reduxObjektiList, dispatch } = this.props;

        this.setState({ loading: true, error: null });

        try {
            const isApstiprinats = novertejumsData?.statuss === 'apstiprināts';
            const [ietekmesPasakumiResult, parametriResult, preventiviePasakumiResult] = await Promise.all([
                dispatch(loadRiskaNovertejumuPasakumi(riskaNovertejumsId)),
                dispatch(loadRiskaNovertejumaParametri(riskaNovertejumsId)),
                isApstiprinats
                    ? dispatch(loadRiskaNovertejumaPreventiviePasakumiSnapshot(riskaNovertejumsId))
                    : dispatch(loadRiskaPreventiviePasakumi())
            ]);

            this.setState({
                loading: false,
                latestAssessment: novertejumsData,
                objektiList: reduxObjektiList || [],
                ietekmesPasakumi: parseListResult(ietekmesPasakumiResult),
                parametriList: parseListResult(parametriResult),
                preventiviePasakumi: parseListResult(preventiviePasakumiResult)
            });
        } catch (error) {
            this.setState({
                loading: false,
                error: error.message || 'Kļūda ielādējot datus'
            });
        }
    }

    loadBasinData = async () => {
        const { id, dispatch } = this.props;

        if (!id) {
            this.setState({ loading: false, error: 'Nav norādīts baseina ID' });
            return;
        }

        this.setState({ loading: true, error: null });

        try {
            const listResult = await dispatch(loadRiskaNovertejumiList(id));
            const assessmentsList = listResult || [];

            const approved = assessmentsList.filter(a => a.statuss === 'apstiprināts');
            if (approved.length === 0) {
                this.setState({ loading: false, latestAssessment: null });
                return;
            }

            const sorted = [...approved].sort((a, b) => {
                const dateA = new Date(a.datums || 0);
                const dateB = new Date(b.datums || 0);
                if (dateB - dateA !== 0) return dateB - dateA;
                return (parseInt(b.id) || 0) - (parseInt(a.id) || 0);
            });
            const latestFromList = sorted[0];

            const [fullNovertejums, objektiResult, ietekmesPasakumiResult, parametriResult, preventiviePasakumiResult] = await Promise.all([
                dispatch(loadRiskaNovertejums(latestFromList.id)),
                dispatch(loadRiskaNovertejumuObjekti(latestFromList.id)),
                dispatch(loadRiskaNovertejumuPasakumi(latestFromList.id)),
                dispatch(loadRiskaNovertejumaParametri(latestFromList.id)),
                dispatch(loadRiskaNovertejumaPreventiviePasakumiSnapshot(latestFromList.id))
            ]);

            this.setState({
                loading: false,
                latestAssessment: { ...latestFromList, ...fullNovertejums },
                objektiList: parseListResult(objektiResult),
                ietekmesPasakumi: parseListResult(ietekmesPasakumiResult),
                parametriList: parseListResult(parametriResult),
                preventiviePasakumi: parseListResult(preventiviePasakumiResult)
            });

        } catch (error) {
            this.setState({
                loading: false,
                error: error.message || 'Kļūda ielādējot datus'
            });
        }
    }

    buildExportData = () => {
        const { latestAssessment, objektiList, parametriList, preventiviePasakumi, ietekmesPasakumi } = this.state;
        const { kodif, novertejumsData } = this.props;
        const assessment = this.isAssessmentMode() ? novertejumsData : latestAssessment;

        if (!assessment) return null;

        const formatValue = (value, fallback = '-') => {
            if (value === 0) return '0';
            if (value === null || value === undefined) return fallback;
            const text = String(value).trim();
            return text || fallback;
        };

        let zemesLietojumsRows = [];
        let zemesLietojumsData = assessment.zemes_lietojums_detalizeti;

        if (typeof zemesLietojumsData === 'string') {
            try {
                zemesLietojumsData = JSON.parse(zemesLietojumsData);
            } catch (e) {
                zemesLietojumsData = [];
            }
        }

        if (Array.isArray(zemesLietojumsData)) {
            zemesLietojumsRows = zemesLietojumsData.map(item => ({
                veids: formatValue(item.zemes_lietosanas_veids),
                izplatiba: formatValue(item.izplatiba_procenti)
            }));
        }

        const uivList = (assessment.urbumi_snapshot || []).map(u => u.urbumi_id).filter(Boolean).join(', ');

        let maksimalaisRisks = parseFloat(assessment.maksimalais_risks || 0) || 0;
        if (maksimalaisRisks === 0 && objektiList && objektiList.length > 0) {
            objektiList.forEach(obj => {
                const novertejums = parseFloat(obj.novertejums || 0);
                if (!isNaN(novertejums) && novertejums > maksimalaisRisks) {
                    maksimalaisRisks = novertejums;
                }
            });
        }

        const riskaKategorijas = (objektiList || []).map(obj => {
            const risk = getRiskLevel(parseFloat(obj.novertejums || 0));
            return {
                label: formatValue(obj.nosaukums_display || obj.nosaukums),
                riskLabel: risk.label || '-',
                color: risk.color || '#f8f9fa'
            };
        });

        const midpoint = Math.ceil(riskaKategorijas.length / 2);

        const kategorijaScoreMap = {};
        (objektiList || []).forEach(kat => {
            kategorijaScoreMap[kat.id] = parseFloat(kat.novertejums) || 0;
        });

        const obligatieNames = new Set();
        const rekomendetieNames = new Set();

        (parametriList || []).forEach(parametrs => {
            const score = kategorijaScoreMap[parametrs.riska_novertejuma_kategorijas_id] || 0;
            const name = parametrs.riska_parametrs_nosaukums;

            if (!name) return;

            if (score >= 10) {
                obligatieNames.add(name);
            } else {
                rekomendetieNames.add(name);
            }
        });

        obligatieNames.forEach(name => rekomendetieNames.delete(name));

        let piezimes = [];
        if (this.isAssessmentMode()) {
            piezimes = formatValue(assessment.kopsavilkuma_piezimes, '')
                .split('\n')
                .map(text => text.trim())
                .filter(Boolean);
        }

        if (piezimes.length === 0) {
            const piezimesObj = kodif?.DZUSB_KOPS_PIEZ;
            if (piezimesObj && typeof piezimesObj === 'object') {
                piezimes = Object.values(piezimesObj)
                    .map(item => formatValue(item.vertiba, ''))
                    .filter(Boolean);
            }
        }

        return {
            datums: assessment.datums,
            pamatinfoRows: [
                { label: 'Sateces baseina kods', value: formatValue(assessment.baseina_kods) },
                { label: 'Ūdensapgādes sistēmas nosaukums', value: formatValue(assessment.uas_nosaukums) },
                { label: 'Operators', value: formatValue(assessment.uas_operators) },
                { label: 'Atļaujas Nr.', value: formatValue(assessment.uas_atlaujas_nr) },
                {
                    label: 'Sateces baseina platība, ha',
                    value: assessment.platiba || assessment.platiba === 0 ? `${assessment.platiba} ha` : '-'
                },
                { label: 'Piederība pazemes ūdeņu atradnei', value: formatValue(assessment.urbumi_atradnes_nosaukums) },
                { label: 'Ūdens ieguves vietas DB Nr.', value: formatValue(uivList) },
                { label: 'Pazemes ūdensobjekts', value: formatValue(assessment.pazemes_udensobjekts) },
                { label: 'Administratīvā teritorija', value: formatValue(assessment.admin_teritorija) },
                { label: 'Ūdens nesējslānis', value: formatValue(assessment.nesejslana_horizonta_indekss) },
                { label: 'Aizsargātības pakāpe', value: formatValue(assessment.aizsargatiba) }
            ],
            zemesLietojumsRows,
            aizsargjoslasRows: (assessment.urbumi_snapshot || []).map(item => ([
                formatValue(item.urbumi_id),
                formatValue(item.stingra_aizsargjosla_snapshot),
                formatValue(item.bakter_aizsargjosla_snapshot),
                formatValue(item.kim_aizsargjosla_snapshot),
                formatValue(item.pasakumi_snapshot),
                formatValue(item.piezimes_snapshot)
            ])),
            riskaKategorijuKolonnas: [
                riskaKategorijas.slice(0, midpoint),
                riskaKategorijas.slice(midpoint)
            ],
            galaRiskLevel: getRiskLevel(maksimalaisRisks),
            sledziens: formatValue(assessment.sledziens, ''),
            obligatieParametri: [...obligatieNames].sort(),
            rekomendetieParametri: [...rekomendetieNames].sort(),
            ietekmesPasakumi: (ietekmesPasakumi || []).map(item => formatValue(item.apraksts, '')).filter(Boolean),
            preventiviePasakumi: (preventiviePasakumi || []).map(item => formatValue(item.piezimes, '')).filter(Boolean),
            piezimes
        };
    }

    handleExportDocx = () => {
        const exportData = this.buildExportData();
        if (!exportData) return;
        exportKopsavilkumsFromDomDocx(this.contentRef.current, this.mapRef.current, exportData);
    }

    renderInfoRow = (label, value) => (
        <FormGroup row>
            <Col xs={12} md={4} className="formlabel-col">
                <Label className="field-label" style={{ fontWeight: 'bold' }}>{label}</Label>
            </Col>
            <Col xs={12} md={8}>
                {value || '-'}
            </Col>
        </FormGroup>
    )

    renderPamatinfo = () => {
        if (this.isAssessmentMode()) {
            const { novertejumsData } = this.props;
            if (!novertejumsData) return null;

            const uivList = (novertejumsData.urbumi_snapshot || []).map(u => u.urbumi_id).filter(Boolean).join(', ');

            return (
                <FormCard title="Sateces baseina pamatinformācija" size={12}>
                    {this.renderInfoRow('Sateces baseina kods', novertejumsData.baseina_kods)}
                    {this.renderInfoRow('Ūdensapgādes sistēmas nosaukums', novertejumsData.uas_nosaukums)}
                    {this.renderInfoRow('Operators', novertejumsData.uas_operators)}
                    {this.renderInfoRow('Atļaujas Nr.', novertejumsData.uas_atlaujas_nr)}
                    {this.renderInfoRow('Sateces baseina platība, ha', novertejumsData.platiba ? `${novertejumsData.platiba} ha` : null)}
                    {this.renderInfoRow('Piederība pazemes ūdeņu atradnei', novertejumsData.urbumi_atradnes_nosaukums)}
                    {this.renderInfoRow('Ūdens ieguves vietas DB Nr.', uivList)}
                    {this.renderInfoRow('Pazemes ūdensobjekts', novertejumsData.pazemes_udensobjekts)}
                    {this.renderInfoRow('Administratīvā teritorija', novertejumsData.admin_teritorija)}
                    {this.renderInfoRow('Ūdens nesējslānis', novertejumsData.nesejslana_horizonta_indekss)}
                    {this.renderInfoRow('Aizsargātības pakāpe', novertejumsData.aizsargatiba)}
                    {novertejumsData.zemes_lietojums_detalizeti && (
                        <FormGroup row>
                            <Col xs={12} md={4} className="formlabel-col">
                                <Label className="field-label" style={{ fontWeight: 'bold' }}>Zemes lietošanas veids</Label>
                            </Col>
                            <Col xs={12} md={8}>
                                {renderZemesLietojumsTable(novertejumsData)}
                            </Col>
                        </FormGroup>
                    )}
                </FormCard>
            );
        }

        const { latestAssessment } = this.state;
        if (!latestAssessment) return null;

        const uivList = (latestAssessment.urbumi_snapshot || []).map(u => u.urbumi_id).filter(Boolean).join(', ');

        return (
            <FormCard title="Sateces baseina pamatinformācija" size={12}>
                {this.renderInfoRow('Sateces baseina kods', latestAssessment.baseina_kods)}
                {this.renderInfoRow('Ūdensapgādes sistēmas nosaukums', latestAssessment.uas_nosaukums)}
                {this.renderInfoRow('Operators', latestAssessment.uas_operators)}
                {this.renderInfoRow('Atļaujas Nr.', latestAssessment.uas_atlaujas_nr)}
                {this.renderInfoRow('Sateces baseina platība, ha', latestAssessment.platiba ? `${latestAssessment.platiba} ha` : null)}
                {this.renderInfoRow('Piederība pazemes ūdeņu atradnei', latestAssessment.urbumi_atradnes_nosaukums)}
                {this.renderInfoRow('Ūdens ieguves vietas DB Nr.', uivList)}
                {this.renderInfoRow('Pazemes ūdensobjekts', latestAssessment.pazemes_udensobjekts)}
                {this.renderInfoRow('Administratīvā teritorija', latestAssessment.admin_teritorija)}
                {this.renderInfoRow('Ūdens nesējslānis', latestAssessment.nesejslana_horizonta_indekss)}
                {this.renderInfoRow('Aizsargātības pakāpe', latestAssessment.aizsargatiba)}
                {latestAssessment.zemes_lietojums_detalizeti && (
                    <FormGroup row>
                        <Col xs={12} md={4} className="formlabel-col">
                            <Label className="field-label" style={{ fontWeight: 'bold' }}>Zemes lietošanas veids</Label>
                        </Col>
                        <Col xs={12} md={8}>
                            {renderZemesLietojumsTable(latestAssessment)}
                        </Col>
                    </FormGroup>
                )}
            </FormCard>
        );
    }

    renderMap = () => {
        if (this.isAssessmentMode()) {
            const { novertejumsData } = this.props;
            if (!novertejumsData || !novertejumsData.geom) return null;

            const urbumiSnapshot = novertejumsData.urbumi_snapshot || [];
            const urbumiFeatures = urbumiSnapshot.map(u => ({
                ...u,
                urb_nr_pirmavota: u.nr_pirmavota_snapshot,
                urb_adrese: u.adrese_snapshot,
                geom: u.geom_snapshot
            }));

            const vectorLayerCfg = {
                dzeramaUdensBaseinaGeometrija: {
                    title: 'Sateces baseina ģeometrija',
                    features: [{ id: 'baseins_snapshot', geom: novertejumsData.geom }],
                    styles: baseinsStyle,
                    zoomTo: 'baseins_snapshot',
                },
                ...(urbumiFeatures.length > 0 && {
                    dzeramaUdensSatecesBaseinsUrbumi: {
                        title: 'Ūdens ieguves vietas',
                        features: urbumiFeatures,
                        styles: dzurUrbumiStyle,
                        tooltipFunc: (feat) => `${feat.get('urbumi_id')}: ${feat.get('urb_nr_pirmavota') || ''} ${feat.get('urb_adrese') || ''}`,
                    }
                })
            };

            return (
                <FormCard title="Sateces baseina aptveres zona" size={12}>
                    <div ref={this.mapRef} style={{ height: '400px', width: '100%' }}>
                        <IzraktenisMap
                            mapId="riska_novertejums_kopsavilkums_karte"
                            vectorLayerCfgs={vectorLayerCfg}
                        />
                    </div>
                </FormCard>
            );
        }

        const { latestAssessment } = this.state;
        if (!latestAssessment || !latestAssessment.geom) return null;

        const urbumiSnapshot = latestAssessment.urbumi_snapshot || [];
        const urbumiFeatures = urbumiSnapshot.map(u => ({
            ...u,
            urb_nr_pirmavota: u.nr_pirmavota_snapshot,
            urb_adrese: u.adrese_snapshot,
            geom: u.geom_snapshot
        }));

        const vectorLayerCfg = {
            dzeramaUdensBaseinaGeometrija: {
                title: 'Sateces baseina ģeometrija',
                features: [{ id: 'baseins_snapshot', geom: latestAssessment.geom }],
                styles: baseinsStyle,
                zoomTo: 'baseins_snapshot',
            },
            ...(urbumiFeatures.length > 0 && {
                dzeramaUdensSatecesBaseinsUrbumi: {
                    title: 'Ūdens ieguves vietas',
                    features: urbumiFeatures,
                    styles: dzurUrbumiStyle,
                    tooltipFunc: (feat) => `${feat.get('urbumi_id')}: ${feat.get('urb_nr_pirmavota') || ''} ${feat.get('urb_adrese') || ''}`,
                }
            })
        };

        return (
            <FormCard title="Sateces baseina aptveres zona" size={12}>
                <div ref={this.mapRef} style={{ height: '400px', width: '100%' }}>
                    <IzraktenisMap
                        mapId="kopsavilkums_karte"
                        vectorLayerCfgs={vectorLayerCfg}
                    />
                </div>
            </FormCard>
        );
    }

    renderAizsargjoslas = () => {
        let data, fields, title;

        if (this.isAssessmentMode()) {
            data = this.props.novertejumsData?.urbumi_snapshot || [];
            fields = ['urbumi_id', 'stingra_aizsargjosla_snapshot', 'bakter_aizsargjosla_snapshot', 'kim_aizsargjosla_snapshot', 'pasakumi_snapshot', 'piezimes_snapshot'];
            title = 'Aizsargjoslas ap ūdens ieguves vietām';
        } else {
            data = this.state.latestAssessment?.urbumi_snapshot || [];
            fields = ['urbumi_id', 'stingra_aizsargjosla_snapshot', 'bakter_aizsargjosla_snapshot', 'kim_aizsargjosla_snapshot', 'pasakumi_snapshot', 'piezimes_snapshot'];
            title = 'Aizsargjoslas ap ūdens ieguves vietām';
        }

        if (data.length === 0) return null;

        const headers = ['Ūdens ieguves vietas DB Nr.', 'Stingra režīma aizsargjosla', 'Bakterioloģiskā aizsargjosla', 'Ķīmiskā aizsargjosla', 'Žogs ap urbumu', 'Piezīmes'];

        return (
            <FormCard title={title} size={12}>
                <table className="table table-striped table-sm">
                    <thead><tr>{headers.map(h => <th key={h}>{h}</th>)}</tr></thead>
                    <tbody>
                        {data.map((item, idx) => (
                            <tr key={item.urbumi_id || idx}>
                                {fields.map(f => <td key={f}>{item[f] || '-'}</td>)}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </FormCard>
        );
    }

    renderRiskaNovertejumaSummary = () => {
        const { latestAssessment, objektiList } = this.state;

        if (!latestAssessment) {
            return (
                <FormCard title="Riska novērtējuma kopsavilkums" size={12}>
                    <Alert color="warning">
                        Sateces baseinam nav veikts riska novērtējums
                    </Alert>
                </FormCard>
            );
        }

        let maksRisks = latestAssessment.maksimalais_risks || 0;
        if (!maksRisks && objektiList && objektiList.length > 0) {
            objektiList.forEach(obj => {
                const nov = parseFloat(obj.novertejums || 0);
                if (!isNaN(nov) && nov > maksRisks) maksRisks = nov;
            });
        }

        const galaRiskLevel = getRiskLevel(maksRisks);

        const midpoint = Math.ceil((objektiList || []).length / 2);
        const leftCol = (objektiList || []).slice(0, midpoint);
        const rightCol = (objektiList || []).slice(midpoint);

        const renderRiskBadge = (obj) => {
            const nov = parseFloat(obj.novertejums || 0);
            const risk = getRiskLevel(nov);
            return (
                <span style={{
                    display: 'inline-block',
                    fontWeight: 'bold',
                    backgroundColor: risk.color || '#f8f9fa',
                    padding: '2px 12px',
                    borderRadius: '3px',
                    minWidth: '120px',
                    textAlign: 'center'
                }}>
                    {risk.label}
                </span>
            );
        };

        const renderCategoryRow = (obj) => (
            <div key={obj.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '4px 0' }}>
                <span style={{ fontWeight: 500 }}>{obj.nosaukums_display || obj.nosaukums}:</span>
                {renderRiskBadge(obj)}
            </div>
        );

        return (
            <FormCard title="Riska novērtējuma kopsavilkums" size={12}>
                {objektiList && objektiList.length > 0 ? (
                    <>
                        <Row>
                            <Col md={6}>
                                {leftCol.map(renderCategoryRow)}
                            </Col>
                            <Col md={6}>
                                {rightCol.map(renderCategoryRow)}
                            </Col>
                        </Row>
                        <div style={{ textAlign: 'center', marginTop: '20px', paddingTop: '12px', borderTop: '1px solid #eee' }}>
                            <span style={{ fontSize: '1.1em', fontWeight: 'bold', marginRight: '12px' }}>Gala novērtējums:</span>
                            <span style={{
                                fontWeight: 'bold',
                                backgroundColor: galaRiskLevel.color,
                                padding: '4px 16px',
                                borderRadius: '3px',
                                fontSize: '1.1em'
                            }}>
                                {galaRiskLevel.label}
                            </span>
                        </div>
                    </>
                ) : (
                    <Alert color="info">Nav riska kategoriju datu</Alert>
                )}
            </FormCard>
        );
    }

    renderSledziens = () => {
        const sledziens = this.isAssessmentMode()
            ? this.props.novertejumsData?.sledziens
            : this.state.latestAssessment?.sledziens;

        if (!this.isAssessmentMode() && !this.state.latestAssessment) return null;

        return (
            <FormCard title="Riska novērtējuma slēdziens" size={12}>
                <div style={{ whiteSpace: 'pre-wrap', padding: '8px' }}>
                    {sledziens || <span className="text-muted">Nav ievadīts slēdziens</span>}
                </div>
            </FormCard>
        );
    }

    renderRiskaParametri = () => {
        const { latestAssessment, objektiList, parametriList } = this.state;

        if (!latestAssessment) return null;

        const kategorijaScoreMap = {};
        (objektiList || []).forEach(kat => {
            kategorijaScoreMap[kat.id] = parseFloat(kat.novertejums) || 0;
        });

        const obligatieNames = new Set();
        const rekomendetieNames = new Set();

        (parametriList || []).forEach(p => {
            const score = kategorijaScoreMap[p.riska_novertejuma_kategorijas_id] || 0;
            const name = p.riska_parametrs_nosaukums;
            if (!name) return;
            if (score >= 10) {
                obligatieNames.add(name);
            } else {
                rekomendetieNames.add(name);
            }
        });

        obligatieNames.forEach(n => rekomendetieNames.delete(n));

        const obligatie = [...obligatieNames].sort();
        const rekomendetie = [...rekomendetieNames].sort();

        if (obligatie.length === 0 && rekomendetie.length === 0) return null;

        const maxRows = Math.max(obligatie.length, rekomendetie.length);

        return (
            <FormCard title="Monitoringā iekļaujamo parametru saraksts" size={12}>
                <table className="table table-bordered table-sm">
                    <thead>
                        <tr>
                            <th style={{ backgroundColor: '#f5f5f5', width: '50%' }}>Obligāti nosakāmie parametri*</th>
                            <th style={{ backgroundColor: '#f5f5f5', width: '50%' }}>Papildus rekomendējamie parametri*</th>
                        </tr>
                    </thead>
                    <tbody>
                        {Array.from({ length: maxRows }, (_, i) => (
                            <tr key={i}>
                                <td>{obligatie[i] || ''}</td>
                                <td>{rekomendetie[i] || ''}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <p style={{ color: '#6c757d', fontSize: '11px', marginTop: '4px' }}>
                    * neapstrādātā pazemes ūdens monitoringā nosakāmie rādītāji, atbilstoši veiktajam riska novērtējumam
                </p>
            </FormCard>
        );
    }

    renderRiskaPasakumi = () => {
        const { latestAssessment, preventiviePasakumi, ietekmesPasakumi } = this.state;

        if (!latestAssessment) {
            return null;
        }

        return (
            <FormCard title="Riska pārvaldības pasākumi" size={12}>
                <h6>Ietekmi mazinošie pasākumi</h6>
                {ietekmesPasakumi.length > 0 ? (
                    <ul>
                        {ietekmesPasakumi.map((p) => (
                            <li key={p.id}>{p.apraksts}</li>
                        ))}
                    </ul>
                ) : (
                    <p className="text-muted">Nav ietekmes mazinošo pasākumu</p>
                )}

                <h6 className="mt-3">Preventīvie pasākumi</h6>
                {preventiviePasakumi.length > 0 ? (
                    <ul>
                        {preventiviePasakumi.map((p) => (
                            <li key={p.id}>{p.piezimes}</li>
                        ))}
                    </ul>
                ) : (
                    <p className="text-muted">Nav preventīvo pasākumu</p>
                )}
            </FormCard>
        );
    }

    renderPiezimes = () => {
        if (this.isAssessmentMode()) {
            const piezimesText = this.props.novertejumsData?.kopsavilkuma_piezimes;
            if (piezimesText) {
                return (
                    <FormCard title="Piezīmes" size={12}>
                        {piezimesText.split('\n').filter(Boolean).map((text, idx) => (
                            <p key={idx}>{text}</p>
                        ))}
                    </FormCard>
                );
            }
            // nav snapshot — rādam no kodifikatora (fallback)
        }

        const { kodif } = this.props;
        const piezimesObj = kodif?.DZUSB_KOPS_PIEZ;
        if (!piezimesObj || typeof piezimesObj !== 'object') return null;
        const items = Object.values(piezimesObj);
        if (items.length === 0) return null;
        return (
            <FormCard title="Piezīmes" size={12}>
                {items.map((item, idx) => (
                    <p key={item.id || idx}>{item.vertiba || '-'}</p>
                ))}
            </FormCard>
        );
    }

    render() {
        const { selectedItem } = this.props;
        const { loading, error, latestAssessment } = this.state;

        if (loading) {
            return <Loading />;
        }

        if (error) {
            return <Alert color="danger">Kļūda: {error}</Alert>;
        }

        if (!this.isAssessmentMode()) {
            if (!selectedItem) {
                return <Alert color="warning">Nav atlasīts sateces baseins</Alert>;
            }

            const hasGeometry = selectedItem.sb_geom || selectedItem.urbumi_atradnes_geom_id;
            if (!hasGeometry) {
                return <NavGeometrijaBridinajums title="Kopsavilkums" />;
            }

            if (!latestAssessment) {
                return <Alert color="info">Kopsavilkums pieejams tikai baseiniem ar apstiprinātu riska novērtējumu</Alert>;
            }
        }

        return (
            <div ref={this.contentRef} style={{ maxHeight: this.isAssessmentMode() ? 'calc(100vh - 250px)' : 'calc(100vh - 200px)', overflowY: 'auto', overflowX: 'hidden' }}>
                {this.renderPamatinfo()}
                {this.renderMap()}
                {this.renderAizsargjoslas()}
                {this.renderRiskaNovertejumaSummary()}
                {this.renderSledziens()}
                {this.renderRiskaParametri()}
                {this.renderRiskaPasakumi()}
                {this.renderPiezimes()}

                <div className="mt-4 mb-4 text-center">
                    <Button
                        color="primary"
                        onClick={this.handleExportDocx}
                        disabled={!latestAssessment}
                    >
                        Eksportēt DOCX
                    </Button>
                    {!latestAssessment && !this.isAssessmentMode() && (
                        <p className="text-muted mt-2 small">
                            Eksports pieejams tikai baseiniem ar veiktu riska novērtējumu
                        </p>
                    )}
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    const dzeramaUdensSatecesBaseins = state.dzeramaUdensSatecesBaseins || {};
    const selectedItem = dzeramaUdensSatecesBaseins.selectedItem || null;

    return {
        id: ownProps.id,
        riskaNovertejumsId: ownProps.riskaNovertejumsId,
        selectedItem,
        kodif: state.kodif || {},
        novertejumsData: (state.riskaNovertejumi || {}).selectedItem,
        reduxObjektiList: (state.riskaNovertejumi || {}).objektiList
    };
};

export default connect(mapStateToProps)(DzeramaUdensSatecesBaseinsKopsavilkums);
